import React, {Component} from 'react';
import axios from '../../axios-signup';
import {Redirect} from 'react-router-dom';
import Error from '../../components/UI/Error';
import wrapper from "../../hoc/wrapper";
import store from '../../store';
import Header from "../../components/Header/Header";
import {Loader} from 'react-overlay-loader'

class EmailValidate extends Component {
    state = {valid: false, verified: false, guid: '', emailAddress: '', loading: true, finished: false, linkExpired: false};

    componentWillMount() {
        const params = new URLSearchParams(this.props.location.search);
        const guid = params.get('guid');
        this.setState({guid: guid});
    }

    componentDidMount() {
        this.setState({loading: true});
        axios.get('/email-verify?guid=' + this.state.guid)
            .then((res) => {
                store.token = res.data.token;
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.token;
                let finished = false;
                if (res.data.finished) {
                    finished = true
                }
                this.setState({verified: true, finished: finished, valid: res.data.valid, linkExpired: res.data.linkExpired, emailAddress: res.data.emailAddress, loading: false});
            })
            .catch(error =>this.setState({errorMsg: error.response.data.error, loading: false}));
    }

    render() {
        let redirect = null;
        const submitted = this.state.verified;
        if (this.state.finished) {
            redirect = <Redirect to={{pathname: '/signup/signup-done', state: {emailAddress: this.state.emailAddress}}}/>
        } else if (submitted && this.state.valid) {
            redirect = <Redirect
                to={{pathname: '/signup/password', state: {valid: this.state.valid, emailAddress: this.state.emailAddress}}}/>
        }

        let errorMsg = null;
        if (submitted && !this.state.valid) {
            if (this.state.linkExpired) {
                errorMsg = 'The email verification link was expired. <br/> For assistance please contact <a href=\'mailto:support@xosphere.io\'>support@xosphere.io</a>'
            } else {
                errorMsg = 'Email not valid. <br/> For assistance please contact <a href=\'mailto:support@xosphere.io\'>support@xosphere.io</a>'
            }
        }
        return (
            <div>
                <Header currentWizard="2"/>
            <main role="main">
                <Loader fullPage={true} loading={this.state.loading}/>
                <section className="section yellow">
                    {redirect}
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 col-md-8 col-center text-center">
                                <Error errorMsg={errorMsg} divClass="col-md-8 col-center"/>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            </div>
        )
    }
}

export default wrapper(EmailValidate);